'use strict';
//signalrService MIGRADO
angular.module('TurneroApp').component('coSidebarAtencionSeleccion', {
    controller: [
        'agendaService',
        'puestosService',
        'utilsService',
        'usuariosService',
        'centrosAtencionService',
        '$localStorage',
        'signalrDotNetCoreService',
        'TurneroAppConstant',
        '$location',
        '$scope',
        function (agendaService, puestosService, utilsService, usuariosService, centrosAtencionService,$localStorage, signalrService, TurneroAppConstant, $location, $scope) {
            var ctrl = this;
            ctrl.Atencion = {
                Agenda: null,
                Atencion: null,
                Puestos: []
            };
            ctrl.centroAtencionSeleccionado = null;
            ctrl.puestoAtencionSeleccionado = null;

            $scope.go = function(path) {
                $location.path(path);
            };

            ctrl.setCentroAtencion = function(centro){
                ctrl.centroAtencionSeleccionado = centro;
            };

            //ctrl.Signalr = signalrService;
            ctrl.disconnectSignalr = function () {
                //signalrService.disconnect();
                //signalrService.stopHub(TurneroAppConstant.HubNames.PUESTOS); <-Esto dependiendo el sincronismo me cierra ANTES DE TIEMPO la conexión...
            }
            
            //el onChange se ejecuta cada vez que cambian los parametros del binding 
            ctrl.$onChanges = function () {
                if (ctrl.centroAtencionSeleccionado && ctrl.centroAtencionSeleccionado.id) {
                    ctrl.limpiarMemoria();
                }
            };

            ctrl.cambiarCentroDeAtencion = async function (centro) {
                ctrl.centroAtencionSeleccionado = centro;
                $localStorage.centroAtencionSeleccionado = centro;
                
                // Limpiar la selección anterior y obtener los puestos del nuevo centro
                await ctrl.limpiarMemoria();
            };

            ctrl.limpiarMemoria = async function () {
                ctrl.Atencion = {
                    Agenda: null,
                    Puesto: null,
                    Atencion: null
                };
                //este codigo elimina del localstorage el id_usuario_sesion
                delete ($localStorage.TurneroApp_UsuarioSesion)
                // Limpiar el puesto de atención seleccionado del localStorage
                delete ($localStorage.PuestoSeleccionado)
                // Limpiar la agenda seleccionada del localStorage
                delete ($localStorage.AgendaSeleccionada)
                ctrl.puestoAtencionSeleccionado = null;
                //cada vez que se limpia la pantalla se obtienen los puestos, para refrescar el estado de los mismos
                await ctrl.getPuestos();
                ctrl.Agendas = null;
                ctrl.Turnos = null;
            }

            //LOGIN Y LOGOUT 
            ctrl.getPuestos = function () {
                //Obtiene los puestos de atencion que estan cargados para ese centro de atencion y tambien retorna los centro usuario para saber si esta logueado un usuario (Ocupado),
                //si el puesto esta asignado al usuario (Mi Puesto), o si esta libre.
                return puestosService.Get_Puestos_Combo_Atencion({
                    'id_centro_atencion': ctrl.centroAtencionSeleccionado.id
                }).$promise.then(function (resultado) {
                    ctrl.Puestos = resultado.Data;
                    return resultado.Data;
                }).catch(function (error) {
                    //Si ocurre un error limpia todo.
                    utilsService.errores(error, function () {
                        ctrl.Atencion.Puesto = null;
                    });
                    throw error;
                });
            }

            ctrl.getAgendas = function (puesto) { //Obtengo las agendas para el usuario logueado para este centro de atencion.
                ctrl.Agendas = null;
                ctrl.Atencion.Agenda = null;
                var UsuarioLogueado = false;

                for (var i = 0; i < ctrl.Puestos.length; i++) { //verifica que el usuario no se encuentre logueado en otro puesto 
                    if (puesto.Id_Centro_Usuario == ctrl.Puestos[i].Id_Centro_Usuario_Puesto) {
                        UsuarioLogueado = true;
                    }
                }

                if (puesto) {
                    if (puesto.Id_Centro_Usuario != puesto.Id_Centro_Usuario_Puesto && UsuarioLogueado) { //si el puesto seleccionado no tiene mi mismo Id_Centro_Usuario y estoy logueado en otro puesto
                        swal({
                            title: 'Atención',
                            html: 'Actualmente existe un puesto logueado con su usuario. <br/> ¿Esta seguro que desea loguearse en otro puesto de atención?',
                            type: 'info',
                            showCancelButton: true,
                            confirmButtonColor: '#004b81',
                            cancelButtonColor: '#971b2f',
                            confirmButtonText: "Sí",
                            cancelButtonText: "No",
                            allowEscapeKey: false,
                            allowOutsideClick: false
                        }).then(function () {
                            //Si se selecciono si, se ejecuta el inicio de sesion, que cierra la sesion anterior y crea un nuevo Id_usuario_sesion
                            ctrl.iniciar_Sesion(puesto);

                        }, function (error) {
                            //hubiera un error o se cierra el modal, por alguna cuestion se limpia el puesto y vuelve al inicio.
                            swal.close();
                            ctrl.Atencion.Puesto = null;

                        })
                    } else {

                        ctrl.iniciar_Sesion(puesto);
                    }
                }
            };

            // Función para cargar agendas sin iniciar sesión (para restauración)
            ctrl.cargarAgendas = function (puesto) {
                return agendaService.Get_Agendas_Combo_Atencion({ 
                    'id_centro_usuario': puesto.Id_Centro_Usuario 
                }).$promise.then(function (resultado) {
                    ctrl.Agendas = resultado.Data;
                    return resultado.Data;
                }).catch(function (error) {
                    utilsService.errores(error);
                    throw error;
                });
            };

            ctrl.iniciar_Sesion = function (puesto) {
                //Se crea el Usuario Sesion para el usuario, para el Puesto.
                usuariosService.Post_Usuario_Sesion_Atencion({
                    'id_centro_atencion': parseInt(ctrl.centroAtencionSeleccionado.id),
                    'id_puesto': parseInt(puesto.id)
                }).$promise.then(function (resultado) {
                    //se obtienen lospuestos de nuevo para cambiar los estados de los puestos
                    ctrl.getPuestos();
                    ctrl.PuestoSeleccionado = puesto;
                    ctrl.Atencion.Puesto = puesto;
                    $localStorage.PuestoSeleccionado = puesto;
                    
                    //Se guardan en el localstorage la informacion que viene desde la db /*EJEMPLO : {"Id_Usuario_Sesion":1187620,"Id_Centro_Usuario":14262,"Puesto":{"Id_Centro_Usuario_Puesto":"","Id_Centro_Usuario":"14262","Id_Padre":"","id":"661","text":"Puesto de Prueba 3"},"Solo_Llamar_Proximo":false,"Llamador_Activo":true}*/
                    $localStorage.TurneroApp_UsuarioSesion = resultado.Data;
                    $localStorage.TurneroApp_UsuarioSesion.Puesto = ctrl.PuestoSeleccionado;
                    ctrl.UsuarioConfig = $localStorage.TurneroApp_UsuarioSesion;

                    //SIGNALR : En este metodo se llama al PuestoHub , y se invoca al metodo TRAERPUESTOS. este metodo lo que hace es refrescar la lista de puestos de 'Estado Puesto de Salon'
                    signalrService.startHub(TurneroAppConstant.HubNames.PUESTOS).then(function (hub) {
                        hub.invoke('TraerPuesto', ctrl.centroAtencionSeleccionado.id, puesto.id).then(function () {
                            console.info("Se invocó a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ": " + err.toString());
                        });
                    });

                    //obtengo las agendas, para el usuario
                    agendaService.Get_Agendas_Combo_Atencion({ 'id_centro_usuario': ctrl.UsuarioConfig.Id_Centro_Usuario }).$promise.then(function (resultado) {
                        ctrl.Agendas = resultado.Data;
                        
                        // Restaurar agenda si existe en localStorage
                        if($localStorage.AgendaSeleccionada){
                            var agendaGuardada = $localStorage.AgendaSeleccionada;
                            var agendaEncontrada = null;
                            
                            if (agendaGuardada === 0) {
                                agendaEncontrada = 0;
                            } else if (agendaGuardada && agendaGuardada.id) {
                                agendaEncontrada = ctrl.Agendas.find(function(agenda) {
                                    return agenda.id == agendaGuardada.id;
                                });
                            }
                            
                            if (agendaEncontrada !== null) {
                                ctrl.Atencion.Agenda = agendaEncontrada;
                            }
                        }
                    }).catch(function (error) {
                        utilsService.errores(error);
                    });
                }).catch(function (error) {
                    utilsService.errores(error, ctrl.getPuestos);
                });
            }

            ctrl.muestraTurnoDetalle = function (bool) {
                //esta variable es utilizada para mostrar la grilla u ocultarla, en el caso de ocultarla se muestra el detalle del turno (para el estado atendido)
                ctrl.turnoDetalles = bool;
            }

            ctrl.postMovimientosAgenda = function (agenda) {
                //se ejecuta cuando el usuario seleciciona alguna agenda
                // Post Movimiento registra en que agenda va a estar trabajando el usuario logueado. 
                // Si el Usuario Seleccionado todas las Agendas se envia "agenda" = 0 sino se envia el objeto de la agenda y en el post se envia el Id de la agenda.
                if (agenda || agenda == 0) {
                    var auxIDagenda = agenda == 0 ? 0 : parseInt(agenda.id);
                    var aux = ctrl.UsuarioConfig;
                    ctrl.UsuarioConfig = null;
                    $localStorage.AgendaSeleccionada = agenda;

                    //ctrl.turnosEnEspera es un metodo que esta definido en el componente atencionListadoComponent 
                    if (ctrl.turnosEnEspera)
                        ctrl.turnosEnEspera(auxIDagenda);

                    usuariosService.Post_Movimiento_Usuario_Sesion({
                        'id_usuario_sesion': aux.Id_Usuario_Sesion,
                        'id_centro_usuario': aux.Id_Centro_Usuario,
                        'id_agenda': agenda == 0 ? null : agenda.id,
                        'id_centro_atencion': parseInt(ctrl.centroAtencionSeleccionado.id)
                    }).$promise.then(function (resultado) {
                        aux.Solo_Llamar_Proximo = resultado.Data.Llamar_Proximo == 'S' ? true : false;
                        aux.Llamador_Activo = resultado.Data.Llamador_Activo ? true : false;
                        aux.Id_Agenda = auxIDagenda;

                        ctrl.UsuarioConfig = aux;//Dispara el $onChanges en el componente de la grilla
                        ctrl.muestraTurnoDetalle(false);
                    }).catch(function (error) {
                        utilsService.errores(error);
                        if (error.data && error.data.IsUserSessionException) {
                            ctrl.limpiarMemoria();
                        } else {
                            ctrl.UsuarioConfig = aux;
                        }
                    })
                }
            }

            ctrl.validarAgendaTurno = function (turno) {
                //si selecciono todas las agendas
                if (ctrl.Atencion.Agenda == 0) {
                    var idx = ctrl.Agendas.findIndex(x => {
                        //si la ultima derivacion fue por agenda verifico que pertenezca a esta
                        if (turno.Agenda_Destino_Deriv)
                            return x.id == turno.Agenda_Destino_Deriv;
                        //si no busco si pertenece a la agenda original
                        else
                            return x.id == turno.Id_Agenda
                    })

                    return idx != -1;
                }
                //si tiene una agenda seleccionada
                else if (ctrl.Atencion.Agenda) {
                    //si la ultima derivacion fue por agenda verifico que pertenezca a esta
                    if (turno.Agenda_Destino_Deriv)
                        return turno.Agenda_Destino_Deriv == ctrl.Atencion.Agenda.id;
                    //si no busco si pertenece a la agenda original
                    else
                        return turno.Id_Agenda == ctrl.Atencion.Agenda.id;
                }
                else
                    return false
            }

            ctrl.validarAgendaTurnoDerivado = function (turno) {

                if (ctrl.Atencion.Agenda == 0) {
                    return ctrl.Agendas.findIndex(x => { return x.id == turno.Agenda_Destino_Deriv }) == -1 ? false : true;
                }
                else if (ctrl.Atencion.Agenda) {
                    return turno.Agenda_Destino_Deriv == ctrl.Atencion.Agenda.id;
                }
                else
                    return false
            }

            ctrl.clearSearchTerm = function () {
                ctrl.searchTerm = '';
            };

            ctrl.$onChanges = function (changesObj) {
                ctrl.promise = centrosAtencionService.getCombo(function (centrosAtencion) {
                    ctrl.centrosAtencion = centrosAtencion;
                    
                    var centroselect = ctrl.centroAtencionSeleccionado;

                    if (centroselect === undefined || centroselect === null || Object.keys(centroselect).length === 0) {
                        var cant = centrosAtencion.length;

                        if (cant === 1) {
                            ctrl.cambiarCentroDeAtencion(centrosAtencion[0]);
                        }
                    }
                });
            };

            ctrl.querySearch = function (query) {
                var results = query ? ctrl.centrosAtencion.filter(createFilterFor(utilsService.removeAccents(query))) : ctrl.centrosAtencion,
                    deferred;
                if (ctrl.simulateQuery) {
                    deferred = $q.defer();
                    $timeout(function () { deferred.resolve(results); }, Math.random() * 1000, false);
                    return deferred.promise;
                } else {
                    return results;
                }
            }
            function createFilterFor(query) {
                var upperQuery = angular.uppercase(query);
                return function filterFn(centro) {
                    centro = utilsService.removeAccents(angular.lowercase(centro.text))
                    return (angular.uppercase(centro).indexOf(upperQuery) >= 0);
                };
            }

            // Función async para inicializar el componente
            ctrl.inicializarComponente = async function() {
                if($localStorage.centroAtencionSeleccionado){
                    ctrl.centroAtencionSeleccionado = $localStorage.centroAtencionSeleccionado;
                    await ctrl.getPuestos();
                    
                    if($localStorage.PuestoSeleccionado){
                        ctrl.Atencion.Puesto = $localStorage.PuestoSeleccionado;
                        ctrl.PuestoSeleccionado = $localStorage.PuestoSeleccionado;
                        
                        await ctrl.cargarAgendas($localStorage.PuestoSeleccionado);
                        
                        if($localStorage.AgendaSeleccionada){
                            
                            var agendaGuardada = $localStorage.AgendaSeleccionada;
                            var agendaEncontrada = null;
                            
                            if (agendaGuardada === 0) {
                                // Si es "Todas mis agendas"
                                agendaEncontrada = 0;
                            } else if (agendaGuardada && agendaGuardada.id) {
                                // Buscar por ID en el array de agendas
                                agendaEncontrada = ctrl.Agendas.find(function(agenda) {
                                    return agenda.id == agendaGuardada.id;
                                });
                            }
                            
                            if (agendaEncontrada !== null) {
                                ctrl.Atencion.Agenda = agendaEncontrada;
                            }
                        }
                    }
                }
            };
            
            ctrl.inicializarComponente();
        }
    ],
    template: require('./sidebarAtencionSeleccion.html')
});



// WEBPACK FOOTER //
// ./app/components/atencion/sidebarAtencionSeleccionComponent.js